import React, { Component } from 'react';
import { IAppState, IAction } from '../../models/action/core';
import { Dispatch } from 'redux';
import { connect } from 'react-redux';
import { ICustomIframeProps } from '../../models/components/custom-iframe';
import BaseModal from '../../modal/base-modal/main';

export class CCustomIframeModal extends Component<ICustomIframeProps> {

  setClose = () => {
    if (this.props.onClose) {
      this.props.onClose();
    }
  };

  setCloseModal = () => {
    this.setClose();
  };

  public render() {
    return (
      <BaseModal
        minWidth={'100vw'}
        modalIsOpen={true}
        onClose={this.setCloseModal}
        headerState={`<h6 class="modal-title d-inline-flex align-items-center" id=${'modal-' + this.props.id}>
          <i class="material-icons mr-2">remove_red_eye</i>${this.props.modalName}</h6>`}
        showHeader={true}
      >
        <div style={{ minHeight: 'Calc(100vh - 150px)' }}>
          <iframe
            id={'iframe-' + this.props.id}
            name={this.props.name}
            style={{
              overflow: 'hidden',
              overflowX: 'hidden',
              overflowY: 'hidden',
              height: '100%',
              width: '100%',
              position: 'absolute',
              top: 0,
              left: 0,
              right: 0,
              bottom: 0,
              border: 0
            }}
            height="100%"
            width="100%"
            src={this.props.src}
            sandbox='allow-scripts allow-same-origin allow-forms allow-downloads allow-popups' 
          />
        </div>
      </BaseModal>
    );
  }
}

const mapStateToProps = (state: IAppState, ownProps: ICustomIframeProps): ICustomIframeProps => {
  if (!state) {
    return ownProps;
  }

  const newProps: ICustomIframeProps = Object.assign({}, ownProps, {
  });
  return newProps;
};

const dispatchProps = (dispatch: Dispatch<IAction>) => {
  return ({
    dispatch
  });
};

const CustomIframeModal = connect(
  mapStateToProps,
  dispatchProps
)(CCustomIframeModal);


export default CustomIframeModal;
